export enum YesNo {
  Yes = 'yes',
  No = 'no',
}
